(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-hefty-keytag]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      var select = box.querySelector('[data-keytag-select]');
      var button = box.querySelector('[data-keytag-add]');
      var status = box.querySelector('[role=status]');
      var money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: box.dataset.currency, currencyDisplay: 'code',
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      Array.from(select.options).forEach(function (option) {
        if (option.value) option.textContent += ' · ' + money.format(Number(option.dataset.priceCents) / 100);
      });
      function productForm() {
        var section = box.closest('[data-section-type=product]');
        return section && section.querySelector('form[action*="/cart/add"]');
      }
      function update() {
        var option = select.options[select.selectedIndex];
        var chosen = !!select.value;
        var image = box.querySelector('img');
        image.hidden = !chosen;
        box.querySelector('.hefty-keytag__price').hidden = !chosen;
        box.querySelector('[data-keytag-name]').hidden = !chosen;
        if (chosen) {
          image.src = option.dataset.image;
          image.alt = option.dataset.name;
          box.querySelector('[data-keytag-name]').textContent = option.dataset.name;
          box.querySelector('[data-keytag-price]').textContent = money.format(Number(option.dataset.priceCents) / 100);
          box.querySelector('[data-keytag-full]').textContent = money.format(Number(option.dataset.fullCents) / 100);
        }
        var form = productForm();
        var buy = form && form.querySelector('[name=add]');
        var disabled = !chosen || box.dataset.busy === 'true' ||
          (box.dataset.context === 'product' && (!buy || buy.disabled || !form.querySelector('[name=id]').value));
        if (button.disabled !== disabled) button.disabled = disabled;
      }
      select.addEventListener('change', update);
      document.addEventListener('change', function (event) {
        if (event.target.closest('form[action*="/cart/add"]')) setTimeout(update, 0);
      });
      var form = productForm();
      if (form) new MutationObserver(update).observe(form, {subtree: true, attributes: true, attributeFilter: ['disabled']});
      button.addEventListener('click', async function () {
        if (button.disabled) return;
        box.dataset.busy = 'true';
        update();
        status.textContent = 'Adding…';
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          var cartResponse = await fetch(root + 'cart.js', {headers: {'Accept': 'application/json'}});
          if (!cartResponse.ok) throw new Error('Could not check your cart. Please try again.');
          var cart = await cartResponse.json();
          var keytagIds = Array.from(select.options).map(function (o) {return Number(o.value);});
          if (cart.items.some(function (item) {return keytagIds.indexOf(item.variant_id) !== -1;})) {
            throw new Error('Your cart already has a keytag. Only one can receive this offer. Review your cart before adding another.');
          }
          var items = [{id: Number(select.value), quantity: 1}];
          if (box.dataset.context === 'product') {
            var selectedForm = productForm();
            var buyButton = selectedForm && selectedForm.querySelector('[name=add]');
            var variant = selectedForm && selectedForm.querySelector('[name=id]');
            if (!buyButton || buyButton.disabled || !variant || !variant.value) throw new Error('Please choose an available T-shirt or hoodie size.');
            items.unshift({id: Number(variant.value), quantity: 1});
          } else {
            // Recheck eligibility through fresh server-rendered Liquid, without changing the cart.
            var htmlResponse = await fetch(root + 'cart?section_id=cart-template', {cache: 'no-store'});
            if (!htmlResponse.ok) throw new Error('Could not check this offer. Please refresh your cart.');
            var html = await htmlResponse.text();
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hefty-keytag]');
            if (!fresh || !fresh.querySelector('option[value="' + select.value + '"]')) throw new Error('This offer has changed. Please refresh your cart.');
          }
          var response = await fetch(root + 'cart/add.js', {
            method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: items})
          });
          var result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Could not add these items. Please try again.');
          window.location.assign(root + 'cart');
        } catch (error) {
          status.textContent = error.message || 'Could not add these items. Please try again.';
          box.dataset.busy = 'false';
          update();
        }
      });
      update();
    });
  }
  init();
  if (!window.heftyKeytagOfferBound) {
    document.addEventListener('shopify:section:load', init);
    window.heftyKeytagOfferBound = true;
  }
})();
